// Generated by scripts/generate-campaign-hero-assets.mjs

export interface CampaignImageCandidate {
  path: string;
  width: number;
}

export interface CampaignImageAsset {
  avif: readonly CampaignImageCandidate[];
  fallback: CampaignImageCandidate;
  height: number;
  jpeg: readonly CampaignImageCandidate[];
  sizes: string;
  width: number;
}

export const MAG7_CAMPAIGN_IMAGES = {
  "card": {
    "avif": [
      {
        "path": "/assets/campaigns/optimized/mag7-card-95ed06e60c73-960.avif",
        "width": 960
      },
      {
        "path": "/assets/campaigns/optimized/mag7-card-95ed06e60c73-1920.avif",
        "width": 1920
      }
    ],
    "fallback": {
      "path": "/assets/campaigns/optimized/mag7-card-95ed06e60c73-1920.jpg",
      "width": 1920
    },
    "height": 795,
    "jpeg": [
      {
        "path": "/assets/campaigns/optimized/mag7-card-95ed06e60c73-960.jpg",
        "width": 960
      },
      {
        "path": "/assets/campaigns/optimized/mag7-card-95ed06e60c73-1920.jpg",
        "width": 1920
      }
    ],
    "sizes": "(min-width: 1280px) 33vw, (min-width: 768px) 50vw, calc(100vw - 2rem)",
    "width": 3960
  },
  "dialog": {
    "avif": [
      {
        "path": "/assets/campaigns/optimized/mag7-dialog-d71e51cfa02c-768.avif",
        "width": 768
      },
      {
        "path": "/assets/campaigns/optimized/mag7-dialog-d71e51cfa02c-1440.avif",
        "width": 1440
      }
    ],
    "fallback": {
      "path": "/assets/campaigns/optimized/mag7-dialog-d71e51cfa02c-1440.jpg",
      "width": 1440
    },
    "height": 780,
    "jpeg": [
      {
        "path": "/assets/campaigns/optimized/mag7-dialog-d71e51cfa02c-768.jpg",
        "width": 768
      },
      {
        "path": "/assets/campaigns/optimized/mag7-dialog-d71e51cfa02c-1440.jpg",
        "width": 1440
      }
    ],
    "sizes": "(min-width: 768px) 42rem, calc(100vw - 2rem)",
    "width": 2016
  },
  "spacex-space": {
    "avif": [
      {
        "path": "/assets/campaigns/optimized/mag7-spacex-space-a593a06f2f6d-768.avif",
        "width": 768
      },
      {
        "path": "/assets/campaigns/optimized/mag7-spacex-space-a593a06f2f6d-1440.avif",
        "width": 1440
      },
      {
        "path": "/assets/campaigns/optimized/mag7-spacex-space-a593a06f2f6d-2400.avif",
        "width": 2400
      }
    ],
    "fallback": {
      "path": "/assets/campaigns/optimized/mag7-spacex-space-a593a06f2f6d-2400.jpg",
      "width": 2400
    },
    "height": 3072,
    "jpeg": [
      {
        "path": "/assets/campaigns/optimized/mag7-spacex-space-a593a06f2f6d-768.jpg",
        "width": 768
      },
      {
        "path": "/assets/campaigns/optimized/mag7-spacex-space-a593a06f2f6d-1440.jpg",
        "width": 1440
      },
      {
        "path": "/assets/campaigns/optimized/mag7-spacex-space-a593a06f2f6d-2400.jpg",
        "width": 2400
      }
    ],
    "sizes": "(min-width: 768px) 42rem, calc(100vw - 2rem)",
    "width": 4096
  }
} as const satisfies Record<"card" | "dialog" | "spacex-space", CampaignImageAsset>;
